// id strings for messages/hub.ts. Same keys and {variables} as en there.
import type { Dict } from "../index";

const hub: Dict = {
  "hub.views.count": "10 miliar+",
  "hub.views.on": "penayangan di",
  "hub.badge.covers": "10 juta+ cover dibuat",
  "hub.badge.quality": "Kualitas studio",
  "hub.badge.youtube": "Seperti yang dilihat di YouTube",
  "hub.trending": "Trending",
  "hub.popular": "Suara populer saat ini",
  "hub.browseAll": "Lihat semua",
  "hub.byCategory": "Jelajahi suara per kategori",
  "hub.aiVoices": "Suara AI",
  "hub.howItWorks": "Cara kerjanya",
  "hub.faq": "Pertanyaan yang sering diajukan",
  "hub.keepExploring": "Jelajahi lagi",
  "hub.moreWays": "Lebih banyak cara berkarya dengan Jammable.",
  "hub.home": "Beranda",

  "widget.title": "Pilih suara untuk mulai",
  "widget.search": "Cari suara",
  "widget.clear": "Hapus pencarian",
  "widget.matching": 'Suara yang cocok dengan "{q}"',
  "widget.popular": "Populer saat ini",
  "widget.noMatch": "Tidak ada suara yang cocok.",
  "widget.searchAny": "Cari suara apa pun di atas.",
  "widget.coverWith": "Buat cover dengan {name}",
  "widget.start": "Mulai dengan suara apa pun",
  "widget.rights":
    "Selanjutnya kamu tambahkan audiomu. Upload hanya audio yang boleh kamu gunakan.",

  "lang.viewThisPage": "Lihat halaman ini dalam Bahasa Indonesia",
  "lang.dismiss": "Tutup",
};

export default hub;
